import React, { Component } from "react";
import PropTypes from "prop-types";
import { CSSTransitionGroup } from "react-transition-group";
import "./Coachmarks.css";

class Coachmarks extends Component {
  constructor() {
    super();

    this.state = {
      showKudosCoachmark: true,
      showConcernsCoachmark: true,
      showFinishCoachmark: true,
    };
  }

  dismissCoachmark = key => {
    this.setState({
      [key]: false,
    });
  };

  renderDismissLink = coachmark => {
    let key;
    if (coachmark === "kudos") {
      key = "showKudosCoachmark";
    } else if (coachmark === "concerns") {
      key = "showConcernsCoachmark";
    } else if (coachmark === "finish") {
      key = "showFinishCoachmark";
    }

    return (
      <div className="dismiss-container">
        <span className="dismiss" onClick={() => this.dismissCoachmark(key)}>
          Dismiss.
        </span>
      </div>
    );
  };

  render() {
    const kudosCoachmark = (
      <div className="kudos-coachmark">
        <div className="line-container">
          <div className="dot" />
          <div className="line" />
        </div>
        <div className="help-text-container">
          <div className="help-text">
            Every time a team member gives kudos to someone, tap this button.
            {this.renderDismissLink("kudos")}
          </div>
        </div>
      </div>
    );

    const concernsCoachmark = (
      <div className="concerns-coachmark">
        <div className="line-container">
          <div className="dot" />
          <div className="line" />
        </div>
        <div className="help-text-container">
          <div className="help-text">
            When a team member raises a concern, add it here for further
            discussion.
            {this.renderDismissLink("concerns")}
          </div>
        </div>
      </div>
    );

    const finishCoachmark = (
      <div className="finish-coachmark">
        <div className="help-text-container">
          <div className="help-text">
            Once the retro has ended, finish the meeting to see your team's
            stats.
            {this.renderDismissLink("finish")}
          </div>
        </div>
        <div className="line-container">
          <div className="dot" />
          <div className="line" />
        </div>
      </div>
    );

    const renderCoachmarks = (
      <div className="coachmarks-outer-container">
        <div className="coachmarks-inner-container">
          <CSSTransitionGroup
            component="div"
            className="kudos-coachmark-container"
            transitionName="coachmarks-transition"
            transitionAppear={false}
            transitionAppearTimeout={0}
            transitionEnterTimeout={0}
            transitionLeaveTimeout={300}
          >
            {this.props.kudosGiven > 0 || !this.state.showKudosCoachmark
              ? null
              : kudosCoachmark}
          </CSSTransitionGroup>
          <CSSTransitionGroup
            component="div"
            className="concerns-coachmark-container"
            transitionName="coachmarks-transition"
            transitionAppear={false}
            transitionAppearTimeout={0}
            transitionEnterTimeout={0}
            transitionLeaveTimeout={300}
          >
            {this.props.concernsLength > 0 || !this.state.showConcernsCoachmark
              ? null
              : concernsCoachmark}
          </CSSTransitionGroup>
          <CSSTransitionGroup
            component="div"
            className="finish-coachmark-container"
            transitionName="coachmarks-transition"
            transitionAppear={false}
            transitionAppearTimeout={0}
            transitionEnterTimeout={0}
            transitionLeaveTimeout={300}
          >
            {!this.state.showFinishCoachmark ? null : finishCoachmark}
          </CSSTransitionGroup>
        </div>
      </div>
    );
    return (
      <CSSTransitionGroup
        transitionName="coachmarks-transition"
        transitionAppear={false}
        transitionAppearTimeout={0}
        transitionEnterTimeout={0}
        transitionLeaveTimeout={300}
      >
        {this.props.retroSessionsCount > 0 && this.props.concernsLength > 0
          ? null
          : renderCoachmarks}
      </CSSTransitionGroup>
    );
  }
}

Coachmarks.propTypes = {
  kudosGiven: PropTypes.number.isRequired,
  concernsLength: PropTypes.number.isRequired,
  retroSessionsCount: PropTypes.number.isRequired,
};

export default Coachmarks;



// WEBPACK FOOTER //
// ./src/components/Coachmarks.js